import React, { useCallback, useEffect, useState } from "react";
import * as services from "../../../../services/product.services";
import { serverResponse } from "../../../../util/fakeServer";
import { connect } from "react-redux";
import ManagerFactory from "../../../../managers/ManagerFactory";

const manager = ManagerFactory.getManager();

const Price = ({
  strike_price,
  price,
  offer_price,
  discount_rate,
  price_label,
  no_price,
  fontSize = "1rem",
  styleContainer = {},
  styleParagraph = "unset",
  customClass = true,
  skul,
  dynamic_price,
  dynamic_info,
  price_for_kg,
  left = "unset",
  top = "unset",
  getPrice = true,
  priceReducer,
}) => {
  const formattedPrice = (el, symbol = "") =>
    `${symbol}${parseFloat(el).toFixed(2).toString().replace(".", ",")}`;

  const [serverPrice, setServerPrice] = useState(null);
  const [loadingPrice, setLoadingPrice] = useState(
    dynamic_price && !dynamic_info && getPrice
  );

  const getPriceForItem = useCallback(async () => {
    try {
      const {
        data: { data: res },
      } = await services.getPrices([skul], serverResponse.config.id_listino);

      if (res) {
        setServerPrice(res[0][skul]);
        setLoadingPrice(false);
      }
    } catch (error) {
      console.log(error);
    }
  }, [skul]);

  useEffect(() => {
    if (dynamic_price && !dynamic_info && getPrice) {
      getPriceForItem();
    }
  }, [dynamic_price, dynamic_info, getPrice, getPriceForItem]);

  const classes = "priceinner";
  const symbol = "€ ";

  if (no_price) return null;

  if (
    (loadingPrice || priceReducer.isLoading) &&
    !(skul in priceReducer.productPrices) &&
    dynamic_price
  ) {
    return (
      <div
        className="spinner-grow "
        style={{
          width: "5rem",
          height: "5rem",
          color: serverResponse.config.secondary_color,
        }}
        role="status"
      />
    );
  }

  const symbolEuro = (str) => (
    <>
      {str && !str.includes(symbol) && (
        <span
          className="currency"
          style={{
            fontWeight: "700",
            color: "#0d0040",
          }}
        >
          €{" "}
        </span>
      )}
      {str && str.toString().replace(/(\d+)\.(\d+)/g, "$1,$2")}
    </>
  );

  const hasEuroChar = price_label.indexOf("€") === 0;

  const priceLabel = () => {
    if (dynamic_price && !dynamic_info) return symbolEuro(serverPrice);

    if (serverResponse.config.client_id === 3531) {
      let priceToReturn = price_label
        .toString()
        .replace(/(\d+)\.(\d+)/g, "$1,$2");
      if (hasEuroChar)
        return priceToReturn.replace("€", " ") + (hasEuroChar ? " €" : "");
      else return priceToReturn;
    }

    if (hasEuroChar)
      return symbolEuro(
        price_label.replace(/(\d+)\.(\d+)/g, "$1,$2").replace("€", "")
      );

    return price_label.replace(/(\d+)\.(\d+)/g, "$1,$2");
  };

  const getPriceLabel = (
    <>
      <span
        className="product-price-block"
        style={{
          display: "inline-flex",
          flexDirection: "column",
        }}
      >
        <span
          className="price_span"
          style={{
            fontFamily: "Rubik",
            color: "#0D0040",
          }}
        >
          {priceLabel()}
        </span>
      </span>
      {!!manager.getIvaLabel() && (
        <span
          style={{
            fontSize: `calc(${fontSize} - 1rem)`,
            lineHeight: "2rem",
            fontWeight: "900",
            color: serverResponse.config.primary_color,
            whiteSpace: "nowrap",
          }}
          className="price_span d-block d-lg-inline"
        >
          {" "}
          {manager.getIvaLabel()}
        </span>
      )}
    </>
  );

  return (
    <>
      {!!(!getPrice && dynamic_price) && (
        <>
          <p
            className="price_span mt-3"
            style={{
              fontSize: fontSize,
              lineHeight: "2rem",
              fontWeight: "900",
              color: serverResponse.config.primary_color,
              whiteSpace: "nowrap",
            }}
          >
            {symbolEuro(priceReducer.productPrices[skul])}
          </p>
        </>
      )}
      { 
        // <div className={`product-price`} style={styleContainer}>
        <>
          {offer_price && (
            <>
              <p className="barrato offerPrice">
                {dynamic_price && !dynamic_info ? serverPrice : `€ ${price}`}
              </p>
              <p
                className={`${customClass ? classes : ""}`}
                style={{ fontWeight: "bold", paddingRight: styleParagraph }}
              >
                {discount_rate !== undefined &&
                  parseFloat(discount_rate) !== 0 &&
                  discount_rate !== null && (
                    <span className="discount-rate">{discount_rate}%</span>
                  )}
                {getPriceLabel}
              </p>
            </>
          )}
          {!offer_price && (
            <div className="product-price-block">
              <div className="priceBlock">
                {getPriceLabel}
                {discount_rate !== undefined &&
                  parseFloat(discount_rate) !== 0 &&
                  discount_rate !== null && (
                    <span className="discount-rate">{discount_rate}%</span>
                  )}
              </div>
            </div>
          )}
          {price_for_kg && (
            <p className="priceKg">{price_for_kg}</p>
          )}
        </>
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    priceReducer: state.priceReducer,
  };
};
export default connect(mapStateToProps, null)(Price);
